<div class="justify-content-center" width="100%">
  <div class="row header_design pb-4">
    <div class="col-lg-12 col-12">
      <div class="logo mt-3">
        <a href="#"><img style="width:125px;" src="../../../assets/img/Logo resized.svg" width="100%"></a>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
  <div class="col-lg-8 mt-5">
  <form [formGroup]="" class="mt-4 formStyle">
    <div class="col-sm-12 pt-2 pb-2 text-center form_header">
      Upload Floorplan
    </div>
    <div class="form-group row m-0">
      <div class="col-md-8 mt-4 d-flex">
        <label class="customLabel"><strong>Name</strong></label>
       <span class="form_style">{{ name }}</span>
      </div>
    </div>
  <div>
    <div class="col-sm-12 pt-2 pb-2 mt-4 form_header">
      Upload
    </div>  
  <div class="col-sm-8 border_upload">
    <div class="form-group"> 
      <!-- <label class="piform col-sm-6 pl-0 pb-2 mt-4 upload_width">Upload</label> -->
      <input type="file" class="pi-file mt-4" style=" width: 82%;"  (change) = "updateSmsFile($event)">
      <!-- <button class="btn btn-pink" (click)="uploadFileEvent()" disabled type="upload">Upload</button> -->
      <button type="upload" class="btn btn-pink mt-lg-0 mt-3" (click)="uploadFormFileEvent()" disabled>Upload</button>
    </div>
  </div>
  </div>
  <div class="rk-ui-notification w-75" *ngIf="successalert">
    <span id="notificationMessageText">{{successMessage}}</span>
    <a class="close rk-linknotification" (click)="successalert=false">×</a>
  </div>
  <div class="rk-ui-notification err w-75" *ngIf="erroralert">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
  </form>
  </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/lead/sms-floorplan-form-upload/sms-floorplan-form-upload.component.html